var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileProductIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44425 0.151931C2.62549 0.196455 4.63608 1.93545 4.77018 2.09364L4.24699 3.74611L2.59458 4.2693C-1.37506 -0.42299 1.17515 7.97274 4.7938 6.076C4.83173 6.12102 4.87192 6.16549 4.91526 6.2093C4.91317 6.20689 9.5972 11.1714 9.61558 11.1903C11.0027 12.5108 13.058 10.5297 11.731 9.07484C11.7286 9.07232 11.7263 9.07001 11.7237 9.0677L6.70927 4.41359C6.66665 4.37117 6.62209 4.33177 6.57633 4.29463C7.3789 2.38095 5.70358 -0.0745983 3.44425 0.151931ZM11.0302 9.3954C12.1301 10.8378 8.93589 11.4523 9.87455 9.39522C10.0848 9.21117 10.4871 9.06219 11.0302 9.3954Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileProductIcon);
export default __webpack_public_path__ + "static/media/profile-product-icon.d05db966c9274c0fbb3463f31f0ea650.svg";
export { ForwardRef as ReactComponent };